import toast from 'react-hot-toast';
import SessionToast from '../components/tag/SessionToast';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { SESSION } from '../data/reducer';
import {
  setLastActive,
  setSessionAlertActive,
  setSessionAlertInactive,
} from '../data/session/actions';
import { getTime } from './TimeUtils';
import { getFrontendProperties } from '../definitions/Config';
import SessionUtils from './SessionUtils';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import OTButton from '../components/tag/OTButton';

const Session = (props) => {
  const {
    lastAction,
    setLastActive,
    sessionAlertActive,
    sessionStarted,
    setSessionAlertActive,
    setSessionAlertInactive,
  } = props;

  const {
    sessionMaxLengthWarnTime,
    sessionMaxLengthLogoutTime,
    inactivityWarnTime,
    inactivityLogoutTime,
  } = getFrontendProperties();

  const MINUTES = 60000;

  const sessionMaxLengthWarnTimeInMilliseconds = sessionMaxLengthWarnTime * MINUTES;
  const sessionMaxLengthLogoutTimeInMilliseconds = sessionMaxLengthLogoutTime * MINUTES;
  const inactivityWarnTimeInMilliseconds = inactivityWarnTime * MINUTES;
  const timeFromAlertToLogout = (inactivityLogoutTime - inactivityWarnTime) * MINUTES;
  const now = getTime();
  const timeSinceLogin = moment
    .duration(now.diff(sessionStarted))
    .asMilliseconds();

  const remainingSessionMaxLengthWarnTime = sessionMaxLengthWarnTimeInMilliseconds - timeSinceLogin;
  const remainingSessionMaxLengthLogoutTime = sessionMaxLengthLogoutTimeInMilliseconds - timeSinceLogin;

  function showSessionMaxLengthAlert() {
    toast(
      (t) => {
        return (
          <>
            <FormattedMessage id={`session.max.length.toast`} />
            <OTButton onClick={() => toast.dismiss(t.id)}>
              <FormattedMessage id={`OK`}>{(txt) => txt}</FormattedMessage>
            </OTButton>
          </>
        );
      },
      { className: 'ot-session-toast__box', duration: Infinity }
    );
  }

  function showSessionInactivityAlert() {
    toast(
      (t) => (
        <SessionToast continueSession={continueSession} sessionToast={t} />
      ),
      { className: 'ot-session-toast__box', duration: Infinity }
    );
  }

  //Timer from last action to session alert
  useEffect(() => {
    if (!sessionAlertActive) {
      const alertTimer = setTimeout(() => {
        showSessionInactivityAlert();
        setSessionAlertActive();
      }, inactivityWarnTimeInMilliseconds);
      return () => {
        clearTimeout(alertTimer);
      };
    }
  }, [lastAction]);

  //Timer from session alert to logout
  useEffect(() => {
    if (sessionAlertActive) {
      const logoutTimer = setTimeout(() => {
        SessionUtils.logout({ internalLogoutReason: 'SESSION_INACTIVITY' });
      }, timeFromAlertToLogout);
      return () => {
        clearTimeout(logoutTimer);
      };
    }
  }, [sessionAlertActive]);

  //Timer for session max length
  useEffect(() => {
    const sessionMaxLengthWarnTimer = setTimeout(() => {
      showSessionMaxLengthAlert();
    }, remainingSessionMaxLengthWarnTime);

    const sessionMaxLengthLogoutTimer = setTimeout(() => {
      SessionUtils.logout({ internalLogoutReason: 'SESSION_MAX_LENGTH' });
    }, remainingSessionMaxLengthLogoutTime);
    return () => {
      clearTimeout(sessionMaxLengthWarnTimer);
      clearTimeout(sessionMaxLengthLogoutTimer);
    };
  }, [sessionStarted]);

  //When user clicks the continue-button in session alert
  const continueSession = (t) => {
    toast.dismiss(t.id);
    setSessionAlertInactive();
    setLastActive(getTime());
  };

  return null;
};

const mapStateToProps = (state) => {
  return {
    sessionStarted: state[SESSION].sessionStarted,
    lastAction: state[SESSION].lastActive,
    sessionAlertActive: state[SESSION].sessionAlertActive,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLastActive: () => dispatch(setLastActive()),
    setSessionAlertActive: () => dispatch(setSessionAlertActive()),
    setSessionAlertInactive: () => dispatch(setSessionAlertInactive()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Session);
